/**
 * Run promise one after another (sequentially)
 * @param tasks
 * @param fn promise factory function. Will take task as parameter an returns a Promise
 */
export function promiseSerial(tasks, fn) {
    return tasks.reduce((promise, task, index) => {
        return promise.then(() => fn(task, index));
    }, Promise.resolve());
}
